let fr = {
  translations: {
    nav_menu: {
      home: "HOME",
      link_home: "https://www.ecat.it/fr/",
      reserved_area: "ZONE RÉSERVÉE",
      link_reserved_area: "https://www.ecat.it/fr/zone-reservee/",
      products: "PRODUITS",
      link_products: "https://www.ecat.it/fr/produits/",
      gallery: "GALLERY",
      link_gallery: "https://www.ecat.it/fr/gallery/",
      support: "SUPPORT",
      link_support: "https://www.ecat.it/fr/support/",
      contact_us: "CONTACTEZ-NOUS",
      link_contact_us: "https://www.ecat.it/fr/informacion/",
    },
    nav_menuburger: {
      home: "Home",
      link_home: "https://www.ecat.it/fr/",
      reserved_area: "Zone réservée",
      link_reserved_area: "https://www.ecat.it/fr/zone-reservee/",
      products: "Produits",
      link_products: "https://www.ecat.it/fr/produits/",
      gallery: "Gallery",
      link_gallery: "https://www.ecat.it/fr/gallery/",
      support: "Support",
      link_support: "https://www.ecat.it/fr/support/",
      contact_us: "Contactez-nous",
      link_contact_us: "https://www.ecat.it/fr/informacion/",
    },
    footer: {
      privacy_policy: "Privacy policy",
      cookies_policy: "Cookies policy",
      certification: " ISO Certification",
      company_policy: " Company policy",
      condition: "  Warranty and condition",
      sales_contract: "EKlok sales contract",
      return_policy: "Return Policy",
      link_privacy_policy: "https://www.ecat.it/fr/privacy-policy/",
      link_cookies_policy: "https://www.ecat.it/fr/cookie/",
      link_certification: "https://www.ecat.it/src/html/doc/9001_Inglese.pdf",
      link_company_policy: "https://www.ecat.it/fr/company_policy/",
      link_condition: "https://www.ecat.it/src/html/doc/sale_conditions.pdf",
      link_sales_contract:
        "https://www.ecat.it/src/html/doc/contratto_eklok_eng.pdf",
      link_return_policy:
        "https://www.ecat.it/src/html/doc/return_policy_eng.pdf",
    },
    device_frame: {
      timeout: "Le temps de connexion a expiré",
    },
    errors: {
      user_disabled: 'Compte désactivé. Veuillez contacter le support.',
      http_400: "Requête invalide.",
      http_401:
        "Identifiants invalides ou session expirée. Veuillez vous connecter.",
      http_403: "Vous n'avez pas les permissions pour effectuer cette action.",
      http_404: "Ressource introuvable.",
      http_409: "Conflit avec l'état actuel de la ressource.",
      http_422: "Les données envoyées sont invalides.",
      http_429: "Trop de requêtes. Réessayez dans un instant.",
      http_500: "Erreur interne du serveur. Réessayez plus tard.",
      http_502: "Serveur inaccessible. Réessayez plus tard.",
      http_503: "Service temporairement indisponible.",
      http_504: "Délai du serveur dépassé. Réessayez plus tard.",
      network: "Impossible de contacter le serveur. Vérifiez votre connexion.",
      unknown: "Une erreur inattendue s'est produite.",
    },
  },
};

export default fr;
